<template>
  <div>
    <v-card class="mb-4" :loading="loading">
      <v-system-bar>verpasste Prüfung</v-system-bar>
      <v-alert type="info" text
        >Es wird nur überprüft ob der/die Schüler/in in einer Lektion abwesend
        war, wo im Kurs eine Probe eingetragen war! (Doppellektionen erscheinen
        zweimal, es können auch z.B. Vorträge erscheinen, welche diese Person
        nicht direkt betreffen)</v-alert
      >
      <v-list>
        <v-list-item v-for="(examAbsence, index) of examAbsences" :key="index">
          <v-list-item-content>
            <v-list-item-title>
              {{ formatDate(examAbsence.absence.date, true) }},
              {{ examAbsence.absence.startTime }} –
              {{ examAbsence.absence.endTime }}
            </v-list-item-title>
            <v-list-item-subtitle>
              Absenz:
              <strong>
                <span v-if="examAbsence.absence.justificationCategory">
                  {{
                    examAbsence.absence.justificationCategory.description
                  }}</span
                >
                ({{ examAbsence.absence.status.description }})</strong
              >, gemeldet von {{ examAbsence.absence.teacher.code }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Kurs:
              <strong>{{ examAbsence.exam.course.title }}</strong>
              ({{
                examAbsence.exam.course.teachers
                  .map((teacher) => teacher.code)
                  .join(", ")
              }})
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              Prüfung:
              <strong>{{ examAbsence.exam.title }}</strong>
              {{ examAbsence.exam.description }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { formatDate } from "common/utils/date";

export default defineComponent({
  props: {
    id: { type: Number, default: 0 },
    term: { startDate: 0 },
    student: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      loading: false,
      examAbsences: [],
    };
  },

  watch: {
    id(oldValue, newValue) {
      if (oldValue != newValue) {
        this.fetchData();
      }
    },
    term() {
      this.fetchData();
    },
  },

  methods: {
    formatDate,

    async fetchData() {
      if (!this.id || !this.term) return;
      if (!this.$_hasRole("student")) {
        this.loading = true;

        this.examAbsences = (
          await this.apiGet({
            resource: "absence/exam",
            id: this.id,
            query: `term=${this.term.id}`,
          })
        ).items;

        this.loading = false;
      }
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
